import React from "react";
import { IClub } from "@eagerdog/interfaces";
import ClubCalendar from "src/components/ClubCalendar/ClubCalendar";

interface IProps {
  club: IClub;
}

const CalendarTab: React.FC<IProps> = ({ club }) => {
  return <ClubCalendar clubId={club._id.toString()} isAdmin={true} />;
};

export default CalendarTab;
